import React, { useContext } from 'react';
import navigationContext from '../../context/navigationContext';

import './Modal.scss';

type Props = {
  className?: string;
  contentClassName?: string;
  popUpClassName?: string;
  navigationClassName?: string;
  contextKey: string;
  children: React.ReactNode;
};

const Modal: React.FC<Props> = ({
  children,
  className,
  popUpClassName,
  contentClassName,
  navigationClassName,
  contextKey
}) => {
  const context = useContext(navigationContext);
  const { show, hideNavigation } = context[contextKey];

  const handleCloseClick = () => {
    const contextProps = context[contextKey];
    contextProps.handleToggle();
  };

  if (!show) {
    return null;
  }

  return (
    <div className={`${className} background`}>
      <div className="container">
        <div className={`${popUpClassName} popup`}>
          <div className={`${contentClassName} content`}>
            {!hideNavigation && (
              <div className={`${navigationClassName} navigation`}>
                <div
                  role="link"
                  className="pam-close"
                  onClick={handleCloseClick}
                />
              </div>
            )}
            {children}
            {!hideNavigation && (
              <div className={`${navigationClassName} bottom-navigation`}>
                <div
                  role="button"
                  className="bottom-close"
                  onClick={handleCloseClick}>
                  Close
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
